import {  Component,OnDestroy, OnInit } from '@angular/core';
import { ProcesoReporte } from '../../../base/proceso-reporte';
import { AppComponent } from 'src/app/app.component';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as Highcharts from 'highcharts';
import { LlamadasService } from 'src/app/services/seguimiento/llamadas.service';
import { IHeader, Pdf } from 'src/app/clases/pdf';
import { XlsxService } from 'src/app/services/utils/xlsx.service';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
@Component({
  selector: 'app-llamadas',
  templateUrl: './llamadas.component.html',
  styleUrls: ['./llamadas.component.scss']
})
export class LlamadasComponent extends ProcesoReporte implements OnInit {

  grafico !: Highcharts.Chart | undefined | any;
  mostrarGrafico : boolean = false;
  totalDuracionLlamadas = 0;
  totalTiempoLlamada = 0;
  totalPromedio = 0;
  totalLlamadas = 0; 
  pantallaCompletaGrafico : boolean = false;
  opcionesImpresion: MenuItem[] = [
      {
        label: 'Resumido',
        command: () => this.descargar('resumido')
      },
      {
        label: 'Detallado',
        command: () => this.descargar('detallado')
      }
  ];
  responsiveOptions = [
    {
      breakpoint: '1024px',
      numVisible: 3,
      numScroll: 1
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 1
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];

  private refreshInterval: any;
  private colorMap: { [label: string]: string } = {};
  private colorIndex = 0;
  private colorPalette: string[] = [
    '#2ca02c', '#1f77b4', '#ff7f0e', '#d62728',
    '#9467bd', '#8c564b', '#e377c2', '#7f7f7f',
    '#bcbd22', '#17becf'
  ];
  recuperadores: Record< string, any >[] = [];
  resumenRecuperadores: Record< string, any >[] = [];
  datosAnteriores: Record< string, any >[] = [];
  estadosLlamada : Record< string, any >[]= [
    { nombre: 'Respondido', valor:'ANSWERED'},
    { nombre: 'Sin Respuesta', valor:'NO ANSWER'},
    { nombre: 'Ocupado', valor:'BUSY'},
    { nombre: 'Congestion', valor:'CONGESTION'},
  ]
  todosLosEstados = [ 'ANSWERED', 'NO ANSWER', 'BUSY', 'CONGESTION' ]
  totalLlamadasRepetidas = 0;
  totalLlamadasCortas = 0;
  totalLlamadasEfectivas = 0;
  configurarLlamadas = false;
  fgConfigLlamadas : FormGroup< any >;
  condicionLlamadasRepetidas : number = 5;

  constructor(
    public app: AppComponent, 
    private breadcrumbService: AppBreadcrumbService,
    private router: Router,
    private messageService: MessageService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private llamadasService: LlamadasService,
    private xlsxService : XlsxService,
    private confirmationService: ConfirmationService,
  ) {
    super();
    this.crearFormulario();
    this.breadcrumbService.setItems([ { label: 'Llamadas' } ]);
  }
  ngOnInit(): void {
    this.traerRecuperadores();
  }

  async crearFormulario() {
    const hoy = new Date();
    const fechaDesde = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), 0, 0, 0); // 00:00:00
    const fechaHasta = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), 23, 59, 59); // 23:59:59
    
    this.formGroup = this.fb.group({
      fecha_desde: [fechaDesde],
      fecha_hasta: [fechaHasta],
      recuperadores: [[]],
      estado: [ this.todosLosEstados ],
      condicion_llamadas_cortas:[ 60 ],
    });

    this.fgConfigLlamadas = this.fb.group({
      llamadas_cortas: [60, Validators.required ],
      llamadas_repetidas: [ this.condicionLlamadasRepetidas, Validators.required],
    });
  }

  initializeChart() {
    const container = document.getElementById('chart-container') as HTMLElement;

    if (container) {
      this.grafico = Highcharts.chart(container, {
        chart: {
          type: 'column',
          animation: true,
          style: {
            fontSize: '1.3rem', 
          }
        },
        title: {
          text: 'Cantidad de llamadas por recuperador'
        },
        xAxis: {
          categories: [],
          title: {
            text: 'Recuperador'
          },
          labels: {
            rotation: 0,
          }
        },
        yAxis: {
          title: {
            text: 'Cantidad de Llamadas'
          },
          min: 0
        },
        plotOptions: {
          column: {
            grouping: true,
            pointPadding: 0.2,
            borderWidth: 0, 
            dataLabels: {
              enabled: true,
              format: '{point.y}',
              style: {
                  fontSize: '1.1rem',
                  fontWeight: 'bold'
              },
            }
          }
        },
        series: [
          {
            type: 'column',
            name: 'Total de Llamadas',
            data: [],
            color: '#1565C0',
          },
          {
            type: 'column',
            name: 'Llamadas Efectivas',
            data: [], 
            color: '#689f38eb', 
          },
          {
            type: 'column',
            name: 'Llamadas Cortas',
            data: [], 
            color: '#e74c3c', 
          },
          {
            type: 'column',
            name: 'Llamadas Repetidas',
            data: [], 
            color: '#999999',
          }
        ]
      });
    } else {
      console.error('No se encontró el contenedor con id "chart-container"');
    }
  }

  updateChartData() {
    const resumenFinal = this.items;
    const categorias = resumenFinal.map(item => item.usuario);

    const datosTotal = resumenFinal.map(item => ({
      y: item.totalLlamadas,
      color: '#1565C0',
    }));

    const datosRepetidas = resumenFinal.map(item => ({
      y: item.llamadasRepetidas,
      color: '#999999',
    }));

    const datosCortas = resumenFinal.map(item => ({
      y: item.llamadasCortas,
      color: '#e73c3cff',
    }));

    const datosEfectivos = resumenFinal.map(item => ({
      y: item.llamadasEfectivas,
      color: '#689f38eb',
    }));

    if (this.grafico) {
      this.grafico.xAxis[0].setCategories(categorias);
      this.grafico.series[0].setData(datosTotal, false);
      this.grafico.series[1].setData(datosEfectivos, true);
      this.grafico.series[2].setData(datosCortas, true);
      this.grafico.series[3].setData(datosRepetidas, false);

      this.grafico.redraw();
    }
  }

  startAutoRefresh() {
    this.refreshInterval = setInterval(async () => {
      try {
        const filtros = this.formGroup.getRawValue();
        filtros['fecha_desde'] = this.datePipe.transform(filtros.fecha_desde, 'yyyy-MM-dd HH:mm:ss');
        filtros['fecha_hasta'] = this.datePipe.transform(filtros.fecha_hasta, 'yyyy-MM-dd HH:mm:ss');
        filtros['condicion_llamada_corta'] = this.fgConfigLlamadas.getRawValue().llamadas_cortas;
        const res = await this.llamadasService.getLlamadas( filtros );
        const nuevosDatos = this.datosAnteriores.length !== res.resp.length
        if ( nuevosDatos ) {
          this.datosAnteriores = res.resp;
          await this.generarResumenRecuperadores( res.resp )
          this.grafico.series[0].setData([], false);  // Usando setData() para eliminar puntos de manera eficiente
          this.grafico.xAxis[0].setCategories([], false);  // Vaciar las categorías
          this.updateChartData();
        }
      } catch (error) {
        console.error('Error al actualizar llamadas automáticamente:', error);
      }
    }, 5000);
  }

  getColorForLabel(label: string): string {
  if (this.colorMap[label]) {
    return this.colorMap[label];
  }

  const color = this.colorPalette[this.colorIndex % this.colorPalette.length];
  this.colorMap[label] = color;
  this.colorIndex++;

  return color;
}


  async ejecutar(){
    this.items = [];
    this.resumenRecuperadores.length = 0;
    const value = this.formGroup.getRawValue();
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
    try {    
        this.loading = true;
        value['fecha_desde'] = this.datePipe.transform(value.fecha_desde, 'yyyy-MM-dd HH:mm:ss');
        value['fecha_hasta'] = this.datePipe.transform(value.fecha_hasta, 'yyyy-MM-dd HH:mm:ss');
        value['condicion_llamada_corta'] = this.fgConfigLlamadas.getRawValue().llamadas_cortas;
        if( value['recuperadores'] === null ){ value['recuperadores'] = [] }
        const res = await this.llamadasService.getLlamadas( value );

        if( !res.ok ){
          this.messageService.add( {severity: 'error', summary: 'Operacion Incompleta', detail: 'Ocurrio un error al consultar los datos'});
        }
        if( res.resp.length < 1 ) { this.messageService.add( {severity: 'info', summary: 'Sin resultados', detail: 'No se encontraron llamadas'}); }
        else { 
            this.datosAnteriores = res.resp;
            this.mostrarGrafico = true;
            this.grafico = null;
            setTimeout( async () => {
                await this.generarResumenRecuperadores( res.resp );
                await this.initializeChart();
                await this.updateChartData( );
                await this.startAutoRefresh();
              })
        }
        this.loading = false;
    } catch (error: any) {
        this.messageService.add({severity: 'error', 'summary': 'Ocurrio un error al traer las llamadas'})
        console.error( error )
        this.loading = false;
    }
  }


  async traerRecuperadores(){
    try{
      const resp = await this.llamadasService.getRecuperadores();
      this.recuperadores = resp.resp;
      for ( const recuperador of resp.resp ){
        const recuperadores =  [ ...this.formGroup.get('recuperadores').value ]
        recuperadores.push( recuperador.cnam)
        this.formGroup.get('recuperadores').setValue( recuperadores)
      }
    } catch( error ){
        this.messageService.add({severity: 'error', 'summary': 'Ocurrio un error al traer los recuperadores'})
        console.error( error )
    }
  }
  
  async  generarResumenRecuperadores(llamadas: Llamada[]) {
    this.totalDuracionLlamadas = 0;
    this.totalLlamadas = 0;
    this.totalLlamadasRepetidas = 0;
    this.resumenRecuperadores = [];
    this.items = [];

    const combinacionesRepetidas: { [key: string]: number } = {}; 
    for (let llamada of llamadas) {
      const usuarioDestino = `${llamada.usuario}_${llamada.destino}`; 
      // Si la combinación ya existe, incrementamos el contador de repeticiones
      if (combinacionesRepetidas[usuarioDestino] !== undefined) {
        combinacionesRepetidas[usuarioDestino] += 1;
      } else {
        combinacionesRepetidas[usuarioDestino] = 0; 
      }
      llamada.llamadas_repetidas = combinacionesRepetidas[usuarioDestino];
      if (!this.resumenRecuperadores[llamada.usuario]) {
        this.resumenRecuperadores[llamada.usuario] = {
          usuario: llamada.usuario,
          totalLlamadas: llamada.duracion === null ? 0 : 1,
          promedioDuracion: llamada.duracion,
          totalTiempoLlamada: llamada.duracion,
          detalleLlamada: [llamada],
          // color1: this.getColorForLabel(llamada.usuario),
          // color2: this.shadeColor(this.getColorForLabel(llamada.usuario), 40),
          llamadasRepetidas: ( llamada.llamadas_repetidas - ( this.condicionLlamadasRepetidas - 1 ) ) > 0 ? 1 : 0 ,
          llamadasCortas: llamada.llamadas_cortas,
          llamadasEfectivas: llamada.llamadas_efectivas,
        };
        this.totalLlamadas += 1;
        this.totalDuracionLlamadas += llamada.duracion;
        this.totalLlamadasCortas += llamada.llamadas_cortas;
        this.totalLlamadasEfectivas += llamada.llamadas_efectivas;
      } else {
        this.resumenRecuperadores[llamada.usuario]['totalLlamadas'] += 1;
        this.resumenRecuperadores[llamada.usuario]['totalTiempoLlamada'] += llamada.duracion;
        this.resumenRecuperadores[llamada.usuario]['promedioDuracion'] = Math.round(
          this.resumenRecuperadores[llamada.usuario]['totalTiempoLlamada'] / this.resumenRecuperadores[llamada.usuario]['totalLlamadas']
        );
        this.resumenRecuperadores[llamada.usuario]['detalleLlamada'].push(llamada);
        this.resumenRecuperadores[llamada.usuario]['llamadasRepetidas'] += ( llamada.llamadas_repetidas - ( this.condicionLlamadasRepetidas - 1 ) ) > 0 ? 1 : 0;
        this.totalLlamadas += 1;
        this.totalLlamadasRepetidas += llamada.llamadas_repetidas;
        this.totalDuracionLlamadas += llamada.duracion;
      }
    }
    this.totalPromedio = Math.round(this.totalDuracionLlamadas / this.totalLlamadas);
    const resumenArray = Object.values(this.resumenRecuperadores);
    this.items = resumenArray;
    this.resumenRecuperadores = resumenArray;

  }

  shadeColor(color: string, percent: number): string {
    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);

    R = Math.min(255, Math.max(0, Math.round(R + (R * percent / 100))));
    G = Math.min(255, Math.max(0, Math.round(G + (G * percent / 100))));
    B = Math.min(255, Math.max(0, Math.round(B + (B * percent / 100))));

    const RR = R.toString(16).padStart(2, '0');
    const GG = G.toString(16).padStart(2, '0');
    const BB = B.toString(16).padStart(2, '0');

    return `#${RR}${GG}${BB}`;
  }

  obtenerEstado( estado : string ) : string {
    switch( estado ){
      case 'ANSWERED' :
        return 'Respondido'
        break;
      case 'NO ANSWER' :
        return 'Sin Respuesta'
        break;
      case 'BUSY' :
        return 'Ocupado'
        break;
      case 'CONGESTION':
        return 'Congestion'
        break;
      default:
        return '';
        break;
    }
  }

  convertirSegundos(totalSegundos: number): string {
    const horas = Math.floor(totalSegundos / 3600);
    const minutos = Math.floor((totalSegundos % 3600) / 60);
    const segundos = totalSegundos % 60; 

    return `${horas}h ${minutos}m ${segundos}s`;
  }


  async descargar( formato : string ) {
    const value = this.formGroup.getRawValue();
    const pdf = new Pdf(this.currentUser);
    pdf.title = `Informe de Llamadas - Periodo: ${ this.datePipe.transform(value.fecha_desde, 'dd/MM/yyyy')} - ${ this.datePipe.transform(value.fecha_hasta, 'dd/MM/yyyy')}`;
      pdf.headers = [
          { label: 'Usuario', name: 'usuario', type: 'text' },
          { label: 'Total de Llamadas', name: 'totalLlamadas', type: 'number' },
          { label: 'Llamadas Efectivas', name: 'llamadasEfectivas', type: 'number' },
          { label: 'Total de Llamadas Cortas', name: 'llamadasCortas', type: 'number' },
          { label: 'Total de Llamadas Repetidas', name: 'llamadasRepetidas', type: 'number' },
          { label: 'Promedio de Llamadas', name: 'promedioDuracion', type: 'text' },
          { label: 'Total Tiempo en Llamada', name: 'totalTiempoLlamada', type: 'text' },
        ]
        const elementos = JSON.parse(JSON.stringify(this.items));
        for ( const item of elementos ) {
            item["totalTiempoLlamada"] = this.convertirSegundos(item.totalTiempoLlamada);
            item["promedioDuracion"] = this.convertirSegundos(item.promedioDuracion);
            item.detalleLlamada = item.detalleLlamada.map((detalle: any) => {
            return {
                ...detalle,
                duracion: this.convertirSegundos(detalle.duracion), 
                estado: this.obtenerEstado( detalle.estado ),
              };
            });
            let items = null;
            if( formato === 'detallado' ) {
              items = {
                    headers: [
                        { label: 'Fecha de Llamada', name: 'fecha_llamada', type: 'datetime' },
                        { label: 'Destino', name: 'destino', type: 'text' },
                        { label: 'Estado', name: 'estado', type: 'text' },
                        { label: 'Tiempo en llamada', name: 'duracion', type: 'text' },
                    ] as IHeader[],
                    source: item.detalleLlamada as Record< string, any >[],
                }
            } 
            pdf.addSource({ 
                data: item,
                items : items
            });
        }
        const totales = {
          promedio : this.convertirSegundos( this.totalPromedio ),
          llamadas : this.totalLlamadas,
          cortas : this.totalLlamadasCortas,
          duracion : this.convertirSegundos( this.totalDuracionLlamadas ),
          repetidas : this.totalLlamadasRepetidas,
          efectivas : this.totalLlamadasEfectivas,
        }
        pdf.foot = {
            headers: [
                { label: 'Total de Llamadas', name: 'llamadas', type: 'number' },
                { label: 'Total de Efectivas', name: 'efectivas', type: 'number' },
                { label: 'Total de Llamadas Cortas', name: 'cortas', type: 'number' },
                { label: 'Total de Llamadas Repetidas', name: 'repetidas', type: 'number' },
                { label: 'Promedio General', name: 'promedio', type: 'text' },
                { label: 'Total Tiempo en Llamada', name: 'duracion', type: 'text' },
            ],
            source: totales,
        } 
      pdf.exportar();
  }
  
  async descargarExcel() {
      const datos: Record<string, any>[] = [];
      for (const item of this.items) {
          for ( const llamada of item.detalleLlamada) {
              datos.push({
                  "Usuario": llamada.usuario,
                  "Fecha de Llamada":  this.datePipe.transform( llamada.fecha_llamada, 'dd/MM/yyyy HH:mm:ss') ,
                  "Destino": llamada.destino,
                  "Estado": this.obtenerEstado( llamada.estado ),
                  "Tiempo en llamada(Segundos) ": llamada.duracion,
              });
          }
      }
      await this.xlsxService.exportAsExcelFile(datos, 'informe_llamadas');
  }

  mostrarGraficoCompleto( mostrar : boolean ){
    this.pantallaCompletaGrafico = mostrar;
  }
  ngOnDestroy(): void {
    this.detenerIntervalo();
  }

  detenerIntervalo() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }

  reaunudarIntervalo() {
    if( this.items.length !== 0 ){
        this.startAutoRefresh();
    }
  }

  mostrarConfigurarLlamadas( mostrar : boolean ) : void {
    this.configurarLlamadas = mostrar;
  }

  aplicarConfiguracion(){
    this.formGroup.get('condicion_llamadas_cortas').setValue( this.fgConfigLlamadas.getRawValue().llamadas_cortas );
    this.condicionLlamadasRepetidas = this.fgConfigLlamadas.getRawValue().llamadas_repetidas;
    this.configurarLlamadas = false;
    this.ejecutar();
  }
}
interface Llamada {
  fecha_llamada: string;
  destino: string;
  duracion: number;
  estado: string;
  usuario: string;
  llamadas_repetidas: number;
  llamadas_cortas: number;
  llamadas_efectivas: number;
}
